/* tslint:disable:indent */
export enum UptimeRobotMonitorStatus {
	PAUSED = 0,
	NOT_CHECKED_YET = 1,
	UP = 2,
	SEEMS_DOWN = 8,
	DOWN = 9
}

export class UptimeRobotMonitor {

	public id: number;
	public friendlyName: string;
	public url: string;
	public interval: number;
	public status: UptimeRobotMonitorStatus;
	public customUptimeRatio: number;

	constructor(id: number, friendlyName: string, url: string, interval: number, status: UptimeRobotMonitorStatus, customUptimeRatio: number) {
		this.id = id;
		this.friendlyName = friendlyName;
		this.url = url;
		this.interval = interval;
		this.status = status;
		this.customUptimeRatio = customUptimeRatio;
	}

}





